import { render, staticRenderFns } from "./BEvent.vue?vue&type=template&id=8b72da76"
import script from "./BEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BEvent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports